import { generateMore, generateBackgrounds } from "src/modules/editor-v2/services/AIBackgrounds";
import GlobalAPI from '@/modules/batchEditor/services/GlobalAPI';
import {decodeBase64ToBlob, needToRemoveBG} from 'src/utils/helpers';

export const generateAIImages = async (prompt, _urls, productImage, setS3Url, setUrls, setGenerating, aigenerationLayerProgress, activeProject, backgroundURL, activePage, pagesStates, pages, base64) => {

  try {
    const jobId = activeProject?.job_id;
    let productImageId = null;
    const tags = productImage?.getTags();
    let aiGenPNG = null;
    let needBGRemove = false;

    if (tags?.[1]) {
      if (tags[1].startsWith("product-image-id-")) {
        productImageId = tags[1].replace("product-image-id-", "");
      } else if (tags[1].startsWith("product-asset-id-")) {
        productImageId = pagesStates.find(x=>x.page == activePage).imageId;
    }     
          if(base64)
          {
          const formData = new FormData();
          let imageBlob = await decodeBase64ToBlob(base64);
          const myFile = new File([imageBlob], 'image.png', {
            type: 'image/png',
          });
          try {
            needBGRemove = await needToRemoveBG(base64);
          } catch (error) {
            console.error("Error determining background removal necessity:", error);
            needBGRemove = true; 
          }
          formData.append('file', myFile);
          formData.append("jobOrderId", jobId);
          formData.append("imageId", productImageId);
          formData.append("bgRemovedRequired",needBGRemove )
          const newUrlResponse = await GlobalAPI.uploadBeforeGenerateImage(formData);
          aiGenPNG = newUrlResponse?.data?.data;
          setS3Url(newUrlResponse?.data?.data)
        }
    }

    if (!productImageId) {
      throw new Error("Product image ID not found.");
    }

    const dimensions = productImage._dimensions?.getValue();
    const position = productImage._position?.getValue();

    if (!dimensions || !position) {
      throw new Error("Invalid product image dimensions or position.");
    }

    const boundingBox = {
      width: dimensions.width,
      height: dimensions.height,
      xOffset: position.x,
      yOffset: position.y,
    };

    if (!jobId) {
      throw new Error("Active project or job ID is missing.");
    }

    await generateMore(productImageId, prompt, jobId, boundingBox, backgroundURL,aiGenPNG, pages[activePage]?.originalSize?.height, pages[activePage]?.originalSize?.width);
    //Delay as the bacgkrounds id wont be available as soon as we hit generate more
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    await delay(10000);
    // Callback to receive progress updates from generateBackgrounds
    const onProgressUpdate = (updatedUrls) => {
      setUrls(updatedUrls); 
    };

    // Get the initial URLs (with placeholders) and update as more URLs are received
    const urls = await generateBackgrounds(productImageId, prompt, backgroundURL, boundingBox, onProgressUpdate,  pages[activePage]?.originalSize?.height, pages[activePage]?.originalSize?.width);

    return urls;
    
  } catch (error) {
    console.error("Error generating AI image:", error.message || error);
    return [];
  }
};



  